import React from 'react';
import type { VideoEmbedConfig } from './types';
import { getVideoEmbedUrl, getAspectRatioStyle } from './embedUtils';

interface VideoEmbedProps {
  config: VideoEmbedConfig;
  responsive?: boolean;
  lazyLoad?: boolean;
}

export const VideoEmbed: React.FC<VideoEmbedProps> = ({ config, responsive, lazyLoad }) => {
  const videoUrl = getVideoEmbedUrl(config);
  if (!videoUrl) return null;

  if (responsive) {
    return (
      <div className="relative w-full" style={getAspectRatioStyle(config.aspectRatio)}>
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src={videoUrl}
          title="Embedded video"
          frameBorder="0"
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          loading={lazyLoad ? 'lazy' : undefined}
        />
      </div>
    );
  }

  return (
    <iframe
      src={videoUrl}
      width={config.width || '560'}
      height={config.height || '315'}
      title="Embedded video"
      frameBorder="0"
      allowFullScreen
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      loading={lazyLoad ? 'lazy' : undefined}
    />
  );
};
